import { PICKUP } from 'util/constants';

export const isLocationHasOrderOptions = (orderType, store) => {
  if (orderType === PICKUP) return store.pickupOrderOptions?.length > 0;

  return store.deliveryOrderOptions?.length > 0;
};
